import { uniqBy } from "lodash";
import UserModel from "app/models/UserModel";

// Orders connections so each guardian is followed by their managed children
// (same flatMap/uniqBy shape + isFamilyChild tag the scheduling pickers use —
// CFTB-3281 — so the edufii pickers can later share an option_child-style
// indent). edufii also lists the children at the top level (they're connections
// too), so those are dropped first — they show nested under the parent instead.
export function nestFamilyConnections(users: UserModel[]): UserModel[] {
  const nestedChildIds = new Set(
    users.flatMap((user) => (user.children ?? []).map((child) => child.id))
  );

  return uniqBy(
    users
      .filter((user) => !nestedChildIds.has(user.id))
      .flatMap((head) =>
        head.children?.length
          ? [
              head,
              ...head.children.map((child) => ({
                ...child,
                isFamilyChild: true,
              })),
            ]
          : [head]
      ),
    "id"
  );
}
